import type { GetterTree } from "vuex";
import type {
  AlertingState,
  RootState,
  Alert,
  AlertFunction,
  AlertLevel,
  Scenario,
  AlertEvent,
  AlertEventComment,
} from "@/types";

export const getters: GetterTree<AlertingState, RootState> = {
  getAlerts(state): Alert[] {
    return state.alerts.data;
  },
  getAlertsCount(state): number {
    return state.alerts.count;
  },
  getAlertsLoading(state): boolean {
    return state.alerts.loading;
  },
  getAlertsError(state): string | null {
    return state.alerts.error;
  },
  getAlertsExportLoading(state): boolean {
    return state.alertsExport.loading;
  },
  getAlertsExportExportError(state): string | null {
    return state.alertsExport.error;
  },

  getProjectAlerts(state): Alert[] {
    return state.projectAlerts.data;
  },
  getProjectAlertsCount(state): number {
    return state.projectAlerts.count;
  },
  getProjectAlertsLoading(state): boolean {
    return state.projectAlerts.loading;
  },
  getProjectAlertsError(state): string | null {
    return state.projectAlerts.error;
  },
  getAlertsTypes(state): AlertFunction[] {
    return state.alertsTypes.data;
  },
  getAlertsTypesLoading(state): boolean {
    return state.alertsTypes.loading;
  },
  getAlertsTypesError(state): string | null {
    return state.alertsTypes.error;
  },

  getAlertsLevels(state): AlertLevel[] {
    return state.alertsLevels.data;
  },
  getAlertsLevelsLoading(state): boolean {
    return state.alertsLevels.loading;
  },
  getAlertsLevelsError(state): string | null {
    return state.alertsLevels.error;
  },

  getAlertEvents(state): AlertEvent[] {
    return state.events.data;
  },
  getAlertEventsLoading(state): boolean {
    return state.events.loading;
  },
  getAlertEventsError(state): string | null {
    return state.events.error;
  },
  getAlertEventsCount(state): number {
    return state.events.count;
  },
  getEventsExportLoading(state): boolean {
    return state.eventsExport.loading;
  },
  getEventsExportError(state): string | null {
    return state.eventsExport.error;
  },

  getAlertOneEvent(state): AlertEvent {
    return state.event.data;
  },
  getAlertOneEventLoading(state): boolean {
    return state.event.loading;
  },
  getAlertOneEventError(state): string | null {
    return state.event.error;
  },

  getProjectVarsDetails(state): any[] {
    return state.projectVariables.data;
  },
  getProjectVarsDetailsLoading(state): boolean {
    return state.projectVariables.loading;
  },
  getProjectVarsDetailsError(state): string | null {
    return state.projectVariables.error;
  },

  getScenarios(state): Scenario[] {
    return state.scenarios.data;
  },
  getScenariosLoading(state): boolean {
    return state.scenarios.loading;
  },
  getScenariosError(state): string | null {
    return state.scenarios.error;
  },

  getNewScenario(state): Scenario {
    return state.newScenario.data;
  },
  getNewScenarioLoading(state): boolean {
    return state.newScenario.loading;
  },
  getNewScenarioError(state): string | null {
    return state.newScenario.error;
  },
  getComments(state): AlertEventComment[] {
    return state.comments.data;
  },
  getCommentsLoading(state): boolean {
    return state.comments.loading;
  },
  getCommentsError(state): string | null {
    return state.comments.error;
  },
  getAlertSc(state): Scenario[] {
    return state.alertScenarios.data;
  },
  getAlertScLoading(state): boolean {
    return state.alertScenarios.loading;
  },
  getVariableDatas(state): number[] {
    return state.variableDatas.data;
  },
  getVariableDatasLoading(state): boolean {
    return state.variableDatas.loading;
  },
  getDiagnosticData(state): any {
    return state.diagnosticData.data;
  },
};
